(function() {

  'use strict';
  /* global angular */
  /* global regionOptions */
  /* global communityOptions */
  /* global btoa */

  angular
    .module("Milestone")
    .controller('QuickDeliveryHomesRevampCtrl', [
      "$scope",
      "$http",
      "$timeout",
      "$window",
      "$document",
      "$modal",
      "$q",
      "UserDataService",
      function ($scope, $http, $timeout, $window, $document, $modal, $q, UserDataService) {
        var lastFilterParams = '';
        var localStore = {};
        var initializing = true;
        var homesRequestId = 0;
        var maxLoadAttempts = 3;
        var filterWatchTimeout = null;
        var mediaCache = {};

        $scope.urlSearchParams = new URLSearchParams($window.location.search);
        $scope.dropdownMenu1 = false;
        $scope.dropdownMenu2 = false;
        $scope.dropdownMenu3 = false;
        $scope.isFiltersApplied = false;
        $scope.isLoading = true;
        $scope.loadError = false;
        $scope.homes = [];
        $scope.isLoadingHomeMedia = false;
        $scope.showInlineScheduleForm = false;
        $scope.hideScheduleForm = false;
        $scope.showScheduleMessage = false;
        $scope.showScheduleLoader = false;
        $scope.triedScheduleSubmit = false;
        $scope.schedule = {};
        $scope.tourTimes = [
          { name: 'in the morning' },
          { name: 'in the evening' }
        ];
        $scope.labels = {
          timeOfTour: 'preferred time of tour'
        };

        function initScheduleForm(home) {
          UserDataService.getUser().then(function (user) {
            $scope.schedule = angular.copy(user);
            $scope.schedule.opt_in = 1;
            $scope.schedule.origin = window.location.href;
            $scope.schedule.type = 'scheduleATour';
            $scope.schedule.communities = [];
            $scope.schedule.homes = [];
            if (home && home.community_id) {
              $scope.schedule.communities[0] = home.community_id;
            }
            if (home && home.id) {
              $scope.schedule.homes[0] = home.id;
            }
            $scope.schedule.form_id = 177544;
            $scope.schedule.guid = window.getLassoGuid();
            $scope.schedule._form_id = 'schedule_tour_qmi_modal';
          });
        }

        $scope.openScheduleTour = function () {
          $scope.showInlineScheduleForm = !$scope.showInlineScheduleForm;
        };

        $scope.noDate = function () {
          return $scope.schedule.date_of_tour === null;
        };

        $scope.checkScheduleFormValidation = function (form) {
          $scope.triedScheduleSubmit = true;

          if (!form.$valid) {
            return;
          }

          $scope.hideScheduleForm = true;
          $scope.showScheduleLoader = true;
          $http({
            method: 'POST',
            url: '/form/to-database',
            data: $.param($scope.schedule),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).success(function (data) {
            $scope.showScheduleLoader = false;
            $scope.scheduleMessage = data.message;
            $scope.showScheduleMessage = true;
            if (data.status === 'success' && typeof clicky !== 'undefined') {
              clicky.goal('2675');
              clicky.log('/schedule-a-tour/thank-you');
            }
          });
        };

        $scope.homeFilters = {
          regionId: '',
          communityId: '',
          price: '',
          beds: '',
          baths: '',
          sqft: '',
          availability: '',
          sortBy: '',
          page: 1,
        };
        $scope.previouslySelectedRegionId = $scope.homeFilters.regionId;
        $scope.previouslySelectedCommunityId = $scope.homeFilters.communityId;
        $scope.regionOptions = regionOptions || [];
        $scope.communityOptions = communityOptions || [];
        $scope.filteredCommunityOptions = [];
        $scope.filteredCommunityOptions = getFilteredCommunityOptions();

        $scope.pagination = {
          lastPage: 1,
          currentPage: 1,
          pages: [],
        };

        $scope.$watch('dropdownMenu1', function(is, was) {
          var numDropdownsOpen = 0;

          if ($scope.dropdownMenu1) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu2) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu3) {
            numDropdownsOpen++;
          }

          $timeout(function() {
            if (is) {
              $scope.dropdownMenu2 = false;
              $scope.dropdownMenu3 = false;
            }

            if (numDropdownsOpen > 0) {
              $document[0].addEventListener('keydown', $scope.closeFilterDropdowns, false);
            }
          });


        });

        $scope.$watch('dropdownMenu2', function(is, was) {
          var numDropdownsOpen = 0;

          if ($scope.dropdownMenu1) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu2) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu3) {
            numDropdownsOpen++;
          }

          $timeout(function() {
            if (is) {
              $scope.dropdownMenu1 = false;
              $scope.dropdownMenu3 = false;
            }

            if (numDropdownsOpen > 0) {
              $document[0].addEventListener('keydown', $scope.closeFilterDropdowns, false);
            }
          });
        });

        $scope.$watch('dropdownMenu3', function(is, was) {
          var numDropdownsOpen = 0;

          if ($scope.dropdownMenu1) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu2) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu3) {
            numDropdownsOpen++;
          }

          $timeout(function() {
            if (is) {
              $scope.dropdownMenu1 = false;
              $scope.dropdownMenu2 = false;
            }

            if (numDropdownsOpen > 0) {
              $document[0].addEventListener('keydown', $scope.closeFilterDropdowns, false);
            }
          });


        });

        $scope.$watch('homeFilters', function(is, was) {
          // Skip Angular's initial watcher callback and any updates during setup.
          if (initializing || is === was) {
            return;
          }

          if (filterWatchTimeout) {
            $timeout.cancel(filterWatchTimeout);
          }

          filterWatchTimeout = $timeout(function() {
            filterWatchTimeout = null;
            applyFilterDependencies();
            updateUrlParams();
            getFilteredHomes();
          }, 150);
        }, true);

        function loadHomeMedia(home) {
          if (!home || !home.id) {
            return $q.reject('Missing home');
          }

          if (home._mediaLoaded) {
            return $q.when(home);
          }

          if (mediaCache[home.id]) {
            Object.assign(home, mediaCache[home.id]);
            home._mediaLoaded = true;
            return $q.when(home);
          }

          $scope.isLoadingHomeMedia = true;

          return $http.get('/api/homes/' + home.id, {
            timeout: 30000,
          }).then(function(response) {
            mediaCache[home.id] = response.data;
            Object.assign(home, response.data);
            home.has_gallery = !!(home.assets && home.assets.length);
            home._mediaLoaded = true;
            $scope.isLoadingHomeMedia = false;
            return home;
          }, function(error) {
            $scope.isLoadingHomeMedia = false;
            return $q.reject(error);
          });
        }

        $scope.open = function (home) {
          if (home.activate_details_page) {
            $window.open(home.url, '_blank');
            return;
          }

          loadHomeMedia(home).then(function(enrichedHome) {
            $scope.home = enrichedHome;
            $scope.residence = enrichedHome.residence;
            $scope.showInlineScheduleForm = false;
            $scope.hideScheduleForm = false;
            $scope.showScheduleMessage = false;
            initScheduleForm(enrichedHome);

            $modal.open({
              templateUrl: 'availableHomeModalContent.html',
              controller: 'AvailableHomeModalInstanceCtrl',
              windowClass: 'modal-available-home',
              animation: true,
              scope: $scope
            });
          }).catch(function(error) {
            console.log(error);
          });
        };

        $scope.viewFloorPlansAndElevations = function (home) {
          loadHomeMedia(home).then(function(enrichedHome) {
            $scope.home = enrichedHome;
            $scope.residence = enrichedHome.residence;
            $scope.showInlineScheduleForm = false;
            $scope.hideScheduleForm = false;
            $scope.showScheduleMessage = false;
            initScheduleForm(enrichedHome);

            $modal.open({
              templateUrl: 'availableHomeModalContent.html',
              controller: 'AvailableHomeModalInstanceCtrl',
              windowClass: 'modal-available-home',
              animation: true,
              scope: $scope
            });
          }).catch(function(error) {
            console.log(error);
          });
        };

        $scope.gallery = function(home) {
          loadHomeMedia(home).then(function(enrichedHome) {
            $scope.home = enrichedHome;

            $modal.open({
              animation: true,
              templateUrl: 'myModalContent.html',
              controller: 'ModalInstanceCtrl',
              windowClass: 'custom-carousel-modal',
              size: 'lg',
              scope: $scope
            });
          }).catch(function(error) {
            console.log(error);
          });
        };

        $scope.clearFilters = function() {
          $timeout(function() {
            Object.assign($scope.homeFilters, {
              regionId: '',
              communityId: '',
              price: '',
              beds: '',
              baths: '',
              sqft: '',
              availability: '',
              sortBy: '',
            });
          });
        };

        $scope.retryLoadHomes = function() {
          lastFilterParams = '';
          $scope.loadError = false;
          getFilteredHomes();
        };

        $scope.onPageClick = function(page) {
          $scope.pagination.currentPage = page;
          $scope.homeFilters.page = page;
        };

        $scope.onNextClick = function() {
          if ($scope.pagination.currentPage === $scope.pagination.lastPage) {
            return;
          }

          $scope.onPageClick($scope.pagination.currentPage + 1);
        };

        $scope.onPrevClick = function() {
          if ($scope.pagination.currentPage === 1) {
            return;
          }

          $scope.onPageClick($scope.pagination.currentPage - 1);
        };

        $scope.closeFilterDropdowns = function(event) {
          if (!event || event.key === 'Escape') {
            if ($scope.dropdownMenu1) {
              $document.find('#dropdownMenu1').focus();
            }
            if ($scope.dropdownMenu2) {
              $document.find('#dropdownMenu2').focus();
            }
            if ($scope.dropdownMenu3) {
              $document.find('#dropdownMenu3').focus();
            }

            $timeout(function() {
              $scope.dropdownMenu1 = false;
              $scope.dropdownMenu2 = false;
              $scope.dropdownMenu3 = false;
              $document[0].removeEventListener('keydown', $scope.closeFilterDropdowns);
            });
          }
        }

        function getFilteredCommunityOptions() {
          var filteredCommunityOptions = $scope.homeFilters.regionId
            ? $scope.communityOptions.filter(function(community) {
              return community.region_id == $scope.homeFilters.regionId;
            })
            : $scope.communityOptions.filter(function(community) {
              return community;
            });

          return filteredCommunityOptions;
        }

        function applyFilterDependencies() {
          var selectedCommunityOption = $scope.communityOptions.find(function(community) {
            return community.id == $scope.homeFilters.communityId;
          });
          var selectedRegionOption = $scope.regionOptions.find(function(region) {
            return region.id == $scope.homeFilters.regionId;
          });
          var communityBelongsToRegion = selectedRegionOption && selectedCommunityOption && selectedRegionOption.id == selectedCommunityOption.region_id;

          $scope.filteredCommunityOptions = getFilteredCommunityOptions();

          if ($scope.homeFilters.regionId && $scope.homeFilters.regionId !== $scope.previouslySelectedRegionId) {
            Object.assign($scope.homeFilters, {
              sortBy: 'availability--asc',
            });
          }

          if ($scope.homeFilters.regionId && $scope.homeFilters.communityId && !communityBelongsToRegion) {
            Object.assign($scope.homeFilters, {
              communityId: '',
            });
          }

          if (!$scope.homeFilters.regionId && $scope.previouslySelectedRegionId) {
            Object.assign($scope.homeFilters, {
              communityId: '',
            });
          }

          if ($scope.homeFilters.communityId && !$scope.homeFilters.regionId && !$scope.previouslySelectedCommunityId) {
            Object.assign($scope.homeFilters, {
              regionId: selectedCommunityOption.region_id + '',
            });
          }

          $scope.previouslySelectedRegionId = $scope.homeFilters.regionId;
          $scope.previouslySelectedCommunityId = $scope.homeFilters.communityId;
        }

        function setFiltersFromUrlParams() {
          var urlSearchParams = $scope.urlSearchParams;
          var params = $scope.homeFilters;

          if (urlSearchParams.has('regionId')) {
            params.regionId = urlSearchParams.get('regionId');
          }

          if (urlSearchParams.has('communityId')) {
            params.communityId = urlSearchParams.get('communityId');
          }

          if (urlSearchParams.has('price')) {
            params.price = urlSearchParams.get('price');
          }

          if (urlSearchParams.has('beds')) {
            params.beds = urlSearchParams.get('beds');
          }

          if (urlSearchParams.has('baths')) {
            params.baths = urlSearchParams.get('baths');
          }

          if (urlSearchParams.has('sqft')) {
            params.sqft = urlSearchParams.get('sqft');
          }

          if (urlSearchParams.has('sortBy')) {
            params.sortBy = urlSearchParams.get('sortBy');
          }

          if (urlSearchParams.has('page')) {
            params.page = urlSearchParams.get('page');
          }
        }

        function updateUrlParams() {
          var params = $scope.homeFilters;
          Object.keys(params).forEach(function(key) {
            if (!params[key] || params[key] === null || params[key] === undefined || params[key] === '') {
              $scope.urlSearchParams.delete(key);
              return;
            }

            if (key === 'page' && params[key] == 1) {
              $scope.urlSearchParams.delete(key);
              return;
            }

            $scope.urlSearchParams.set(key, params[key]);
          });

          $window.history.replaceState({}, '', $window.location.pathname + '?' + $scope.urlSearchParams.toString());
        }

        function getFilterHash(filters) {
          var sortedKeys = Object.keys(filters).sort();
          var paramString = sortedKeys.map(function (key) {
            return key + '=' + filters[key];
          }).join('&');
          var hash = btoa(paramString);

          return hash;
        }

        function getFilteredHomes(page, attempt) {
          attempt = attempt || 0;
          $scope.homeFilters.page = page || $scope.pagination.currentPage;


          var params = Object.keys($scope.homeFilters).reduce(function(acc, key) {
            if ($scope.homeFilters[key] && $scope.homeFilters[key] !== null && $scope.homeFilters[key] !== undefined && $scope.homeFilters[key] !== '') {
              acc[key] = $scope.homeFilters[key];
            }

            return acc;
          }, {});
          var stringifiedParams = JSON.stringify(params);

          if (attempt === 0 && stringifiedParams === lastFilterParams) {
            return;
          }

          lastFilterParams = stringifiedParams;

          var hash = getFilterHash($scope.homeFilters);

          if (localStore[hash]) {
            $scope.homes = localStore[hash].homes;
            $scope.pagination.currentPage = localStore[hash].currentPage;
            $scope.pagination.lastPage = localStore[hash].lastPage;
            $scope.pagination.pages = localStore[hash].pages;
            $scope.isLoading = false;
            $scope.loadError = false;
            return;
          }

          $scope.isFiltersApplied = false;
          $scope.isLoading = true;
          $scope.loadError = false;

          homesRequestId++;
          var requestId = homesRequestId;

          $http.get('/api/homes', {
            params: params,
            timeout: 30000,
          }).then(function(response) {
            if (requestId !== homesRequestId) {
              return;
            }

            var pages = Array.from({ length: response.data.last_page }, function(_, i) { return i + 1; });
            pages.shift();
            pages.pop();
            $scope.homes = response.data.data;
            $scope.pagination.lastPage = response.data.last_page;
            $scope.pagination.currentPage = response.data.current_page;
            $scope.pagination.pages = pages;
            $scope.isFiltersApplied = response.data.isFiltered;
            $scope.isLoading = false;
            $scope.loadError = false;

            localStore[hash] = {
              homes: $scope.homes,
              currentPage: $scope.pagination.currentPage,
              lastPage: $scope.pagination.lastPage,
              pages: $scope.pagination.pages,
            };
          }).catch(function(error) {
            if (requestId !== homesRequestId) {
              return;
            }

            console.log(error);

            var status = error && error.status;
            var shouldRetry = !status || status >= 500;

            if (shouldRetry && attempt + 1 < maxLoadAttempts) {
              $timeout(function() {
                if (requestId !== homesRequestId) {
                  return;
                }
                getFilteredHomes(page, attempt + 1);
              }, 1000 * (attempt + 1));
              return;
            }

            $scope.isLoading = false;
            $scope.loadError = true;
          });
        }

        setFiltersFromUrlParams();
        applyFilterDependencies();
        updateUrlParams();
        initializing = false;
        getFilteredHomes();
      }
    ])
    .controller('AvailableHomeModalInstanceCtrl', ['$scope', '$modalInstance', function ($scope, $modalInstance) {
      if ($scope.residence === undefined) {
        return null;
      }

      $scope.floorplanElevation = $scope.residence;
      $scope.images = $scope.floorplanElevation.elevations;

      $scope.activeTab = 'floorplans';

      $scope.ok = function () {
        $modalInstance.close();
      };
    }])

    .controller('ModalInstanceCtrl', ["$scope", '$modalInstance',
      function ($scope, $modalInstance) {

        $scope.myInterval = false;
        $scope.noWrapSlides = false;

        $scope.prev = function () {
          $('#carousel-home').carousel('prev');
        };

        $scope.next = function () {
          $('#carousel-home').carousel('next');
        };

        $scope.cancel = function () {
          $modalInstance.dismiss('cancel');
        };

      }
    ])
  ;

})();
